import { render, staticRenderFns } from "./MWarehouses.vue?vue&type=template&id=804b9544&scoped=true&"
import script from "./MWarehouses.vue?vue&type=script&lang=js&"
export * from "./MWarehouses.vue?vue&type=script&lang=js&"
import style0 from "./m-wms.scss?vue&type=style&index=0&id=804b9544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804b9544",
  null
  
)

export default component.exports